"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _index = _interopRequireDefault(require("@insided/shared/uikit/dropdown/index"));

var _preact2 = _interopRequireDefault(require("downshift/preact"));

var _globals = require("@insided/shared/utils/globals");

var _CategoryList = _interopRequireDefault(require("./CategoryList"));

var _QuickLinksList = _interopRequireDefault(require("./QuickLinksList"));

var _urlGenerator = require("@insided/deprecated-preact-components/utils/urlGenerator");

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

// @ts-expect-error downshift/preact doesn't have TypeScript declarations - only React types available
var Trigger = function Trigger(_ref) {
  var href = _ref.href,
      name = _ref.name,
      isLink = _ref.isLink,
      item = _ref.item;

  if (isLink) {
    var _item$external;

    var isExternal = (_item$external = item === null || item === void 0 ? void 0 : item.external) !== null && _item$external !== void 0 ? _item$external : false;
    return (0, _preact.h)("a", {
      style: {
        color: 'inherit'
      },
      href: (0, _absoluteUrlRuntime.resolveUrl)(href),
      target: isExternal ? '_blank' : '',
      rel: isExternal ? 'noreferrer noopener' : ''
    }, name);
  }

  return (0, _preact.h)("span", null, name);
};

var handleChange = function handleChange(item, isHamburgerList, isCustom) {
  if (isHamburgerList && 'children' in item && item.children.length > 0) {
    return;
  } // External links should not be handled by the downshift component


  if (item.external) {
    return;
  }

  if (isCustom && 'children' in item && item.children.length > 0) {
    return;
  }

  if (isCustom && !('url' in item)) {
    return;
  }

  if ('url' in item) {
    globalThis.location.href = item.url;
    return;
  }

  globalThis.location.href = (0, _urlGenerator.generateCategoryUrl)(item.title, item.id);
};

var CategoryMenu = function CategoryMenu(_ref2) {
  var categoriesV2 = _ref2.categoriesV2,
      name = _ref2.name,
      popupName = _ref2.popupName,
      quickLinksClean = _ref2.quickLinks,
      openOnHover = _ref2.openOnHover,
      isHamburgerList = _ref2.isHamburgerList,
      item = _ref2.item,
      isCustom = _ref2.isCustom;
  var categoryMenuRef = (0, _preact.createRef)();
  return (0, _preact.h)(_preact2.default, {
    onChange: function onChange(item) {
      return handleChange(item, isHamburgerList !== null && isHamburgerList !== void 0 ? isHamburgerList : false, isCustom !== null && isCustom !== void 0 ? isCustom : false);
    }
  }, function (_ref3) {
    var getItemProps = _ref3.getItemProps,
        getRootProps = _ref3.getRootProps,
        highlightedIndex = _ref3.highlightedIndex,
        selectHighlightedItem = _ref3.selectHighlightedItem,
        setHighlightedIndex = _ref3.setHighlightedIndex;
    var categoryList = isCustom ? categoriesV2 : categoriesV2.reduce(function (categoryList, parentCategory) {
      return categoryList.concat(parentCategory).concat(parentCategory.children || []);
    }, []);

    var onGlobalKey = function onGlobalKey(direction) {
      if (direction === 'enter') return selectHighlightedItem();
      if (highlightedIndex === null) return setHighlightedIndex(0);
      var newIndex = highlightedIndex + (direction === 'up' ? -1 : 1);
      if (newIndex < 0) newIndex = 0;
      var maxIndex = quickLinksClean.length + categoryList.length - 1;
      if (newIndex >= maxIndex) newIndex = maxIndex;
      setHighlightedIndex(newIndex);
    };

    var rootProps = getRootProps({
      refKey: 'menu-trigger'
    }, {
      suppressRefError: true
    });
    return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
      return (0, _preact.h)(_index.default, (0, _extends2.default)({}, rootProps, {
        popupName: popupName,
        className: "dropdown dropdown--forums-overview",
        onGlobalKey: onGlobalKey,
        openOnHover: modules.includes('MegaMenuUXchanges') && openOnHover,
        trigger: (0, _preact.h)("span", {
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          className: "main-menu-trigger"
        }, (0, _preact.h)(Trigger, {
          isLink: Boolean(modules.includes('MegaMenuUXchanges') && openOnHover && quickLinksClean.length),
          href: (0, _absoluteUrlRuntime.resolveUrl)(quickLinksClean.length ? quickLinksClean[0].url : '#'),
          name: name,
          item: item
        }), (0, _preact.h)(_ChevronDown.default, {
          width: 16,
          height: 16
        }))
      }), (0, _preact.h)("li", {
        "aria-hidden": "true",
        className: "arrow is-hidden-S"
      }), (0, _preact.h)("li", {
        className: "main-menu-list--overflow-scroll",
        ref: categoryMenuRef
      }, Boolean(quickLinksClean.length) && (0, _preact.h)(_QuickLinksList.default, {
        quickLinksClean: quickLinksClean,
        highlightedIndex: highlightedIndex,
        getItemProps: getItemProps
      }), Boolean(categoryList.length) && (0, _preact.h)(_CategoryList.default, {
        categoryList: categoryList,
        getItemProps: getItemProps,
        highlightedIndex: highlightedIndex,
        onGlobalKey: onGlobalKey,
        quickLinksClean: quickLinksClean,
        popupName: popupName,
        isHamburgerList: isHamburgerList,
        categoryMenuRef: categoryMenuRef,
        isCustom: isCustom !== null && isCustom !== void 0 ? isCustom : false
      })));
    });
  });
};

var _default = CategoryMenu;
exports.default = _default;